import PropTypes from 'prop-types';
import React from 'react';
import { renderCheck } from 'ravenjs/utils/viewport';
import { mergeRefs } from 'ravenjs/utils/component';

const Responsive = React.forwardRef((props, ref) => {
    const { size, children, value } = props;

    if (!renderCheck(size, value) || !React.isValidElement(children)) {
        return null;
    }

    // Only fork a ref onto the child when one is actually being forwarded (i.e.
    // Responsive is used as a Tooltip/Popover anchor). Otherwise preserve the
    // original behavior so function-component children are not forced to hold a
    // ref.
    if (!ref && !children.ref) {
        return React.cloneElement(children);
    }

    return React.cloneElement(children, { ref: mergeRefs(ref, children.ref) });
});

Responsive.displayName = 'Responsive';

Responsive.propTypes = {
    size: PropTypes.string,
    children: PropTypes.node,
    value: PropTypes.string,
};

Responsive.defaultProps = {
    size: 'md',
    children: null,
    value: null,
};

export default Responsive;
